import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import type { QuickFilter, RangeFilter } from '@/types/dashboard.type';

type Props = {
  range: RangeFilter;
  quick: QuickFilter;
  onRangeChange: (value: RangeFilter) => void;
  onQuickChange: (value: QuickFilter) => void;
};

export const Filter = ({ range, quick, onRangeChange, onQuickChange }: Props) => {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      <div className="flex-1" />
      <Select value={range} onValueChange={(v: RangeFilter) => onRangeChange(v)}>
        <SelectTrigger className="w-[160px]">
          <SelectValue placeholder="Range" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="7">Last 7 days</SelectItem>
          <SelectItem value="30">Last 30 days</SelectItem>
        </SelectContent>
      </Select>
      <Select value={quick} onValueChange={(v: QuickFilter) => onQuickChange(v)}>
        <SelectTrigger className="w-[160px]">
          <SelectValue placeholder="Quick filter" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="today">Today</SelectItem>
          <SelectItem value="week">This Week</SelectItem>
          <SelectItem value="month">This Month</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
